exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Screener-Builder-Additional-___controls__wrapper___2xgi8{display:flex;justify-content:space-between;align-items:center;margin-bottom:10px}.src-components-Screener-Builder-Additional-___controls__wrapper___2xgi8>div{display:grid;grid-template-columns:auto auto;align-items:center;grid-column-gap:10px;-webkit-column-gap:10px;-moz-column-gap:10px;column-gap:10px}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-Screener-Builder-Additional-___controls__wrapper___2xgi8"
};